module.exports = "/_next/static/images/customer-review-claudia-min-0dfbf228b3cab443a3ba5e2f060bd565.png";